import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceAdvisor } from './api-interfaces/ServiceAdvisor.interface';
import { advisor } from 'src/models/advisor';
import { HelperService } from '../helperService';

@Injectable({
  providedIn: 'root',
})
export class APIServiceAdvisorService {
  ApiURL: string = '';
  constructor(private http: HttpClient,public helperService: HelperService) {
    this.ApiURL = environment.ServiceAdvisorURL + 'ServiceAdvisors';
  }
  public getAdvisorsByWorkshop(workshopId: string): Observable<ServiceAdvisor[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
      };
    return this.http.get<ServiceAdvisor[]>(this.ApiURL + '/bydealer/'+ encodeURIComponent(workshopId),requestOptions);
   }
  public get(id?: string|number): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
      };
    if (id !== null && id !== undefined) {
      return this.http.get(this.ApiURL + encodeURIComponent(id),requestOptions);
    } else {
      return this.http.get(this.ApiURL,requestOptions);
    }
  }

  public getManagementAdvisor(id: number, idOp: number, workshopId?: number): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
      };
    const workshopParam = workshopId ? `/${encodeURIComponent(workshopId)}` : '';
    const url = `${this.ApiURL}/GetServiceAdvisorRetailWorkshops/${encodeURIComponent(id)}/${encodeURIComponent(idOp)}${workshopParam}`;
    
    return this.http.get(url,requestOptions);
  }
  

  public getByWorkshop(id:any): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
      };
      return this.http.get(this.ApiURL+'/GetByAdvisor/' + encodeURIComponent(id),requestOptions)
  }
  public getAvailableAdvisors(date: string, time: string, brandRetailId: number, typeOfServiceId: number):Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
      };
    return   this.http.get(this.ApiURL+`/GetAllAvailableServiceAdvisor/${date}/${time}/${brandRetailId}/${typeOfServiceId}`,requestOptions)
  }
  
    public post(ServiceAdvisor:advisor): Observable<any>{
      const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
      const requestOptions = {
          headers: headers,
        };
      return this.http.post<any>(this.ApiURL, ServiceAdvisor,requestOptions) }

    public put(ServiceAdvisor:advisor): Observable<any>{ 
      const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
      const requestOptions = {
          headers: headers,
        };
      return this.http.put<any>(this.ApiURL, ServiceAdvisor,requestOptions)}
    public delete(id: number):  Observable<any>{ 
      const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
      const requestOptions = {
          headers: headers,
        };
        let apiURL = `${this.ApiURL}${id}`; 
        return this.http.delete(apiURL,requestOptions)
    }
   
}

